import { Link } from 'react-router';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import ContinueShopping from 'components/cart/ContinueShopping';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import EmptyBox from 'images/empty-cart.svg';

import css from 'styles/components/cart/emptyCart.scss';

export const EmptyCustomerCart = ({ onLinkClick }) => {
  const {
    marketplace: {
      defaultMeta: { title },
      cart: { cartName, shopWomensUrl, shopMenUrl, shopShoesUrl, shopBrandText } }
  } = useMartyContext();
  return (
    <>
      <p>Fill up your {cartName} by checking out all the awesome things you can buy on {title} or by adding items from Your Favorites</p>
      <div className={css.links}>
        <Link onClick={onLinkClick} to={shopWomensUrl}>Shop Women's</Link>
        <Link onClick={onLinkClick} to={shopMenUrl}>Shop Men's</Link>
        <Link className={css.shoes} onClick={onLinkClick} to={shopShoesUrl}>Shop Shoes</Link>
        <Link onClick={onLinkClick} to="/c/brands">{shopBrandText}</Link>
      </div>
    </>
  );
};

export const EmptyAnonymousCart = ({ onLinkClick }) => {
  const {
    testId,
    marketplace: {
      defaultMeta: { title },
      cart: { cartName, shopBrandText } }
  } = useMartyContext();

  return (
    <>
      <p>Nothing to see here Yet! Sign in to see items what you've previously placed in your {cartName} or check out all the awesome things you can buy on {title}</p>
      <div className={css.links}>
        <Link onClick={onLinkClick} to="/login">Sign In</Link>
        <Link onClick={onLinkClick} to="/" data-test-id={testId('homeLink')}>Home Page</Link>
        <Link onClick={onLinkClick} to="/c/brands">{shopBrandText}</Link>
        <Link onClick={onLinkClick} to="/c/contact-us">Contact Us</Link>
      </div>
    </>
  );
};

export const EmptyCart = ({ onLinkClick, isCustomer, className, children }) => {
  const { testId, marketplace: { cart:{ cartName } } } = useMartyContext();

  return (
    <SiteAwareMetadata>
      <div className={cn(css.container, className)} data-test-id={testId('emptyCart')}>

        <ContinueShopping />

        <h1>My {cartName}</h1>

        { isCustomer ? <EmptyCustomerCart onLinkClick={onLinkClick} /> : <EmptyAnonymousCart onLinkClick={onLinkClick} /> }
        <img src={EmptyBox} alt="" />

        { children }
      </div>
    </SiteAwareMetadata>
  );
};

const WithErrorBoundaryEmptyCart = withErrorBoundary('EmptyCart', EmptyCart);
export default WithErrorBoundaryEmptyCart;
